import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      Search: "Search topics…",
      "Welcome back": "Welcome back",
      "We've missed you": "We've missed you",
      "overview cards title": "Cards for an overview of the overall concerns",
      // AllResidents: "All Residents",
      // "Alle innbyggere": "All Residents",
      ActiveConcerns: "Active Concerns",
      AutoConfigure: "Auto Configure",
      // "Totalt antall beboere": "Total Residents",
      // "Oversiktstidslinje": "Overview Timeline",
      //////////////////////////////////////////////
      "Sett varslingsterskler": "Set Alert Thresholds",
      "ganger utenfor hjemmet": "Time outside of home",
      tidsskala: "Timescale",
      // "Last step": "Siste steg",
      // Min: "min",
      // Max: "maks",
      // Scale: "skala",
      // Day: "dagers",
      // Week: "uke",
      // Month: "måneder",
      // admin: "admin",
      // nurse: "Sykepleier",
      // Online: "på nett",
      // Offline: "offline",
      // "Not Assigned": "Ikke tildelt",
      // Submit: "Sende inn",
      // Office: "Kontor",
      // Objective: "Objektiv",
      // "No User available in this zone.":
      //   "Ingen bruker tilgjengelig i denne sonen.",
      // "Single Instance": "enkeltforekomst",
      // "Go to Next Activity": "Gå til neste aktivitet",
      // "Times went to toilet": "Times gikk på toalettet",
      // "Time in kitchen": "Tid på kjøkkenet",
      // "Times Per Day": "ganger per dag",
      // "Times Per Week": "ganger per uke",
      // "Times Per Month": "ganger per måned",
      // "Time spent in bed": "Tid brukt i sengen",
      // "Single Event": "Enkelt arrangement",
      // Commulative: "Kommulativ",
      // "Bathroom visits at night": "Badbesøk om natten",
      // "Times coughed": "ganger hostet",
      // "Go Back to Step One": "Gå tilbake til trinn én",
      // "All steps completed - Click below to add resident":
      //   "Alle trinn fullført - Klikk nedenfor for å legge til beboer",
      // "Note: Min values cannot be greater than Max values for any timescale and vice versa.":
      //   "Merk: Min-verdier kan ikke være større enn Maks-verdier for noen tidsskala og omvendt.",
      // "Show presumptive sleep": "Vis anslått søvn",
      // "Delete Staff Member": "Slett medarbeider",
      // "healthcare - admin": "helse-admin",
      // "View Charts": "Se diagrammer",
      // "View Journal": "Se journal",
      // "No concerns to display":
      //   "Gratulerer! Ingen bekymringer å vise",
      // "User Behavior": "Brukeratferd",
      // "Manual Thresholds": "Manuelle terskler",
      // "Resident Data": "Innbyggerdata",
      // "has onboarded resident": "har om bord beboer",
      // Added: "La til",
      // "This action cannot be undone. Please enter the resident id":
      //   "Denne handlingen kan ikke angres. Vennligst skriv inn beboer-ID",
      // "to confirm.": "å bekrefte.",
      // "Overview Timeline": "Oversiktstidslinje",
      // "This action cannot be undone.Please enter the resident id to confirm.":
      //   "Denne handlingen kan ikke angres. Vennligst skriv inn beboer-ID å bekrefte.",
      // "Delete Resident": "Slett beboer",
      // "Max Single cannot be less than Min Single":
      //   "Maks Single kan ikke være mindre enn Min Single",
      // "Min Single cannot be greater than Max Single":
      //   "Min Single kan ikke være større enn Max Single",
      // "Max Month cannot be less than Min Month":
      //   "Maks. måned kan ikke være mindre enn min. måned",
      // "Min Month cannot be greater than Max Month":
      //   "Min. måned kan ikke være større enn maks. måned",
      // "Max Week cannot be less than Min Week":
      //   "Maks uke kan ikke være mindre enn min uke",
      // "Min Week cannot be greater than Max Week":
      //   "Min uke kan ikke være større enn maks uke",
      // "Max Day cannot be less than Min Day":
      //   "Maks dag kan ikke være mindre enn min dag",
      // "Min Day cannot be greater than Max Day":
      //   "Min dag kan ikke være større enn maks dag",
      // "Min is required": "Min kreves",
      // "Min is required": "Min kreves",
      // "Max is required": "Maks er nødvendig",
      // "Hours Per Day": "Timer per dag",
      // "Hours Per Week": "Timer per uke",
      // "Hours Per Month": "Timer per måned",
      // "Something went wrong. Please try again later":
      //   "Noe gikk galt. Prøv igjen senere",
      // "These are manual thresholds you set to raise concerns once the limits are reached.":
      //   "Dette er manuelle terskler du angir for å vekke bekymringer når grensene er nådd.",
    },
  },
  no: {
    translation: {
      Search: "Search topics…",
      "Room number": "Romnummer",
      Ward: "Avdeling",
      Relative: "Pårørende",
      "Modify Access": "Endre tilgang",
      "Start Date": "Startdato",
      ID: "ID",
      Id: "ID",
      "Welcome back": "  Velkommen tilbake",
      "We've missed you": "We've missed you",
      AllResidents: "Alle beboere",
      "Project staff needed this month": "Anslått personalbehov denne måneden",
      "Majority cause of concerns": "Vanligste årsak til bekymring",
      "Might need immediate attention": "Kan trenge umiddelbar oppmerksomhet",
      Health: "Helse",
      Concern: "Bekymring",
      Concerns: "Bekymringer",
      Time: "Tid",
      Status: "Handlinger",
      Zone: "Sone",
      Cancel: "Avbryt",
      Next: "Neste",
      "Profile Details": "Profildetaljer",
      "This action cannot be undone. Please enter the staff id":
        "Denne handlingen kan ikke angres. Vennligst skriv inn personal-ID",
      "to confirm": "å bekrefte",
      "Personal Details": "Personlige opplysninger",
      "All Residents": "Alle beboere",
      "Resident Id": "Beboer-ID",
      "Enter Resident Id": "Skriv inn beboer-ID",
      "Enter Gateway": "Skriv inn gateway",
      Gateway: "Gateway",
      "Add Resident": "Legg til beboer",
      "Excessive Cough": "Overdreven hoste",
      Protected: "Beskyttet",
      "overview cards title":
        "Kort for en oversikt over de generelle bekymringene",
      Residents: "Beboere",
      StartDate: "Startdato",
      ActiveConcerns: "Aktive bekymringer",
      AutoConfigure: "Automatisk  konfigurering",
      AddResident: "Legg til bruker",
      Overview: "Oversikt",
      Zones: "Soner",
      Select: "Plukke ut",
      "Error adding journal entry": "Feil ved å legge til journalpost",
      "No Assigned User": "Ingen tildelt bruker",
      User: "bruker",
      "Type here": "Skriv her",
      "All Zones": "Alle Soner",
      "Search for...": "Søk etter...",
      General: "Generell",
      timeline: "tidslinje",
      Activity: "Aktivitet",
      Audio: "Lyd",
      Nutrition: "Ernæring",
      Sleep: "Sove",
      Activity: "Aktivitet",
      "Must be a valid email": "Må være en gyldig e-post",
      Required: "Obligatorisk",
      "Role is required": "Rolle er påkrevd",
      "Maximum of 10 users": "Maks 10 brukere",
      "Zone Management": "Sonestyring",
      Logs: " Logger",
      Staff: "Ansatte",
      Items: "Varer",
      "Add Tab": "Legg til fane",
      "Add Nurses to Zone": "Legg til sykepleiere til sone",
      Active: "Aktiv",
      Resolved: "Løst",
      Apply: "Søke om",
      "By Concern Level": "Etter bekymringsnivå",
      "By Time": "Etter tid",
      "By Id": "Etter Id",
      Reset: "Nullstille",
      Sort: "Sortere",
      Cancel: "Avbryt",
      "No Data in the filter selected": "Ingen data i filteret som er valgt",
      "No concerns at the moment": "Ingen bekymringer for øyeblikket",
      "No concerns at the moment.": "Ingen bekymringer for øyeblikket.",
      "No rows": "Ingen rader",
      "Bathroom door": "Baderomsdør",
      "Exit door": "Utgangsdør",
      "Fridge": "Kjøleskap",
      "Low": "Lav",
      "Medium": "Middels",
      "High": "Høy",
      "Sun": "Søn",
      "Mon": "Man",
      "Tue": "Tir",
      "Wed": "Ons",
      "Thu": "Tor",
      "Fri": "Fre",
      "Sat": "Lør",
      "Room Overview": "Romoversikt",
      "Daily Activity": "Daglig aktivitet",
      "Timeline": "Tidslinje",
      "Activity Heatmap": "Aktivitetsoversikt",
      "Door Activity": "Døraktivitet",
      "Add Staff": "Legg til ansatt",
      "Add Staff to Zone": "Legg til ansatt i sone",
      "Staff added to zone successfully": "Ansatt lagt til i sonen",
      "Error adding staff to zone": "Feil ved tillegging av ansatt i sone",
      "All staff members are already assigned to this zone.": "Alle ansatte er allerede tildelt denne sonen.",
      "Select at least one staff member": "Velg minst én ansatt",
      "Invite a Relative": "Inviter pårørende",
      "Invite a Relative for": "Inviter pårørende for",
      "Invitation sent successfully": "Invitasjon sendt",
      "Failed to send invitation": "Kunne ikke sende invitasjon",
      "Enter a valid email address": "Skriv inn en gyldig e-postadresse",
      "Invite": "Inviter",
      "Duration": "Varighet",
      "Date": "Dato",
      "of": "av",
      "more than": "mer enn",
      Action: "Handlinger",
      Notifications: "Varsler",
      "Concern Details": "Bekymrings detaljer",
      "Staff Members": "Ansatte",
      "Total Concerns": "Bekymringer totalt",
      "Total Staff Members Live": "Påloggede ansatte",
      "Total Residents": "Totalt antall beboere",
      Settings: "Innstillinger",
      Resident: "Beboer",
      Resolve: "Løs",
      Timestamp: "Tidsstempel",
      Notes: "Notater",
      "Notes...": "Notater...",
      "Resolution Notes": "Løsningstekst",
      "Abnormal night visits": "Unormale nattlige besøk",
      "Please add any notes for resolving this concern":
        "Legg til løsningstekst for å løse bekymringen.",
      Or: "Eller",
      "Add a Journal Entry": "Legg til journalnotat",
      "Journal Logs Resident": "Journallogger Beboer",
      "Are you sure you want to delete the entry?":
        "Er du sikker på at du vil slette oppføringen?",
      "No data in the selected date range":
        "Ingen data i den valgte datoperioden",
      "Add a Subject": "Legg til et emne",
      Back: "Tilbake",
      Hallway: "Gang",
      Bathroom: "Baderom",
      Bedroom: "Soverom",
      "Living Room": "Stue",
      "No Data": "Ingen data",
      Kitchen: "Kjøkken",
      Cough: "Hoste",
      Outside: "Utenfor",
      Bathroom: "Baderom",
      Toilet: "Toalett",
      Sleep: "Søvn",
      Bed: "Seng",
      "Top Concerns": "Topp bekymringer",
      "Times went to the bathroom": "Tidene gikk på do",
      Created: "Opprettet",
      Undo: "Angre",
      "Last Updated": "Sist oppdatert",
      Subject: "Emne",
      Discard: "Kast",
      Continue: "Fortsette",
      "Resolving this issue": "Løser saken",
      "Resolving form": "Løsningsskjema",
      "Resolving at": "Løst hos",
      Withdraw: "Fjern",
      Details: "detaljer",
      Assign: "Tildel",
      Assigned: "tildelt ansatt",
      "select role": "velge rolle",
      "Send Invitations": "Send invitasjoner",
      "Add Users": "Legg til brukere",
      "Invitation Sent": "Invitasjon sendt",
      "Assign Concern": "Tildel bekymring",
      "No resident available in this zone.":
        "Ingen beboer tilgjengelig i denne sonen.",
      "No residents found in the user's zone.":
        "Ingen beboere funnet i brukersonen.",
      Nurse: "Sykepleier",
      Nurses: "Helsepersonell",
      "Select Nurse": "Velg helsepersonell",
      Cancel: "Avbryt",
      Skip: "Hopp over",
      "Mac Address should be 12 characters long":
        "Mac-adressen skal være 12 tegn lang",
      "Mac Address should only contain hex values (a-f, A-F, 0-9)":
        "Mac-adressen skal bare inneholde hex-verdier (a-f, A-F, 0-9)",
      "Gateway is required": "Gateway er nødvendig",
      Required: "Obligatorisk",
      "Raised Time": "Hendelsestidspunkt",
      "Resolved Time": "Løsningstidspunkt",
      "Resolved Note": "Løsningstekst",
      "Add Zone": "Legg til sone",
      Remove: "Fjern",
      "Assign Resident": "Tilordne beboer",
      "Type zone name": "Skriv inn sonenavn",
      Name: "Navn",
      Names: "Navn",
      Close: "Lukk",
      Add: "Legg til",
      Role: "Rolle",
      User: "Bruker",
      Update: "Oppdater",
      "Update Zones": "Oppdater soner",
      "healthcare-admin": "helsevesen-admin",
      "healthcare-nurse": "helsesøster",
      "Search by ID": "Søk på ID",
      "Logs are records of action taken by users":
        "Oversikt over utførte tiltak",
      Next: "Neste",
      "Add staff": "Legg til ansatt",
      "All Team Members": "Alle ansatte",
      Username: "Brukernavn",
      "Sign out": "Logg ut",
      Languages: "Språk",
      Address: "Adresse",
      Phone: "Telefon",
      Pause: "Pause",
      About: "Om",
      "All fields must be filled": "Alle felt må fylles ut",
      "Assign Residents": "Tildel beboere",
      "Update Profile": "Oppdater profil",
      Delete: "Slett",
      Update: "Oppdater",
      Email: "E-post",
      Roles: "Roller",
      Dismiss: "Avskjedige",
      "By User": "Av bruker",
      All: "Alle",
      "All Logs": "Alle logger",
      "Time Period": "Tidsperiode",
      to: "til",
      "Add a Entry": "Legg til en oppføring",
      "No zones assigned": "Ingen soner tildelt ansatt",
      "Assigned Date": "tildelt ansatt dato",
      "Add Users who will have access to the Healthcare portal":
        "Legg til brukere som skal ha tilgang til Healthcare-portalen",
      "Assigned By": "tildelt ansatt av",
      "Are you working today?": "Jobber du i dag?",
      "Please select if you are working": "Velg om du jobber i dag.",
      "Primary Nurse": "Primærsykepleier",
      "Assigned Residents": "tildelt ansatte beboere",
      "Created At": "Opprettet kl",
      "Loud noise (high dB level)": "Høy støy (høyt dB-nivå)",
      "Abnormal night visits": "Unormale nattlige besøk",
      "Excessive coughing": "Overdreven hoste",
      "General activity level (high/low)":
        "Generelt aktivitetsnivå (høyt/lavt)",
      "Bathroom visits frequency (high/low)":
        "Besøksfrekvens på badet (høy/lav)",
      "Excessive time in bathroom": "Overdreven tid på badet",
      "Excessive activity": "Overdreven aktivitet",
      "Left home for too long": "Forlatt hjemmet for lenge",
      "Location of person in house": "Plassering av person i huset",
      "Left home at odd times": "Forlot hjemmet til rare tider",
      "Low or no kitchen use": "Lite eller ingen aktivitet på kjøkkenet",
      "Loneliness using sound": "Ensomhet ved hjelp av lyd",
      "Talking abnormally": "Snakker unormalt",
      "Abnormal toilet activity": "Unormal toalettaktivitet",
      "General abnormal activity": "Generell unormal aktivitet",
      "A new concern has been reported":
        "En ny bekymring er rapportert for {{application_id}} i sone {{zone_name}}. Se gjennom denne saken umiddelbart ved å klikke for å godta og løse problemet.",
      "We are pleased to inform you":
        "Vi har gleden av å informere deg om at primærsykepleieren, {{username}}, nå er tilgjengelig på nettet. Alle henvendelser og saker knyttet til {{application_id}} vil umiddelbart bli omdirigert til deres oppmerksomhet for fortsatt profesjonell behandling.",
      "We hereby confirm that user":
        "Vi bekrefter herved at brukeren {{username}} offisielt har akseptert ansvaret for å løse problemet som ble reist på {{ timestamp }} knyttet til {{ application_id }}, som ligger i sone {{ zone_name }}.",
      "Admin has forwarded a concern":
        "Administrator {{admin_username}} har videresendt en bekymring for vurderingen din. Denne saken, assosiert med {{application_id}} i sone {{zone_name}}, ble opprinnelig tatt opp på {{concern_time}}. Fortsett for å godta eller avvise bekymringen i henhold til den nødvendige protokollen.",
      "Set Alert Thresholds": "Sett varslingsterskler",
      "Time outside of home": "ganger utenfor hjemmet",
      Timescale: "tidsskala",
      "Last step": "Siste steg",
      Min: "min",
      Max: "maks",
      Scale: "skala",
      Day: "dagers",
      Week: "uke",
      Month: "måneder",
      admin: "admin",
      nurse: "Sykepleier",
      Online: "på nett",
      Offline: "offline",
      "Not Assigned": "Ikke tildelt",
      Submit: "Sende inn",
      Office: "Kontor",
      Objective: "Objektiv",
      "No User available in this zone.":
        "Ingen bruker tilgjengelig i denne sonen.",
      "Single Instance": "enkeltforekomst",
      "Go to Next Activity": "Gå til neste aktivitet",
      "Times went to toilet": "Ganger på toalettet",
      "Time in kitchen": "Tid på kjøkkenet",
      "Times Per Day": "ganger per dag",
      "Times Per Week": "ganger per uke",
      "Times Per Month": "ganger per måned",
      "Time spent in bed": "Tid brukt i sengen",
      "Single Event": "Enkelt arrangement",
      Cumulative: "Kumulativ",
      "Zone Residents": "Sonebeboere",
      "Zone Nurses": "Sone sykepleiere",
      "Bathroom visits at night": "Badbesøk om natten",
      "Times coughed": "ganger hostet",
      "Go Back to Step One": "Gå tilbake til trinn én",
      "All steps completed - Click below to add resident":
        "Alle trinn fullført - Klikk nedenfor for å legge til beboer",
      "Note: Min values cannot be greater than Max values for any timescale and vice versa.":
        "Merk: Min-verdier kan ikke være større enn Maks-verdier for noen tidsskala og omvendt.",
      "Show presumptive sleep": "Vis anslått søvn",
      "Delete Staff Member": "Slett medarbeider",
      "healthcare - admin": "helse-admin",
      "View Charts": "Se diagrammer",
      "View Journal": "Se journal",
      "No concerns to display": "Gratulerer! Ingen bekymringer å vise",
      "User Behavior": "Brukeratferd",
      "Manual Thresholds": "Manuelle terskler",
      "Manual Threshold": "Manuell terskel",
      "Resident Data": "Innbyggerdata",
      "has onboarded resident": "har registrert beboer",
      Added: "La til",
      "This action cannot be undone. Please enter the resident id":
        "Denne handlingen kan ikke angres. Vennligst skriv inn beboer-ID",
      "to confirm.": "å bekrefte.",
      "Overview Timeline": "Oversiktstidslinje",
      "This action cannot be undone.Please enter the resident id to confirm.":
        "Denne handlingen kan ikke angres. Vennligst skriv inn beboer-ID å bekrefte.",
      "Delete Resident": "Slett beboer",
      "Max Single cannot be less than Min Single":
        "Maks Single kan ikke være mindre enn Min Single",
      "Min Single cannot be greater than Max Single":
        "Min Single kan ikke være større enn Max Single",
      "Max Month cannot be less than Min Month":
        "Maks. måned kan ikke være mindre enn min. måned",
      "Min Month cannot be greater than Max Month":
        "Min. måned kan ikke være større enn maks. måned",
      "Max Week cannot be less than Min Week":
        "Maks uke kan ikke være mindre enn min uke",
      "Min Week cannot be greater than Max Week":
        "Min uke kan ikke være større enn maks uke",
      "Max Day cannot be less than Min Day":
        "Maks dag kan ikke være mindre enn min dag",
      "Min Day cannot be greater than Max Day":
        "Min dag kan ikke være større enn maks dag",
      "Min is required": "Min kreves",
      "Min is required": "Min kreves",
      "Max is required": "Maks er nødvendig",
      "Hours Per Day": "Timer per dag",
      "Hours Per Week": "Timer per uke",
      "Hours Per Month": "Timer per måned",
      "Something went wrong. Please try again later":
        "Noe gikk galt. Prøv igjen senere",
      Edit: "Rediger",
      "Edit Resident": "Rediger beboer",
      "Resident Details": "Beboerdetaljer",
      "Resident updated successfully": "Beboer oppdatert",
      "First name": "Fornavn",
      Initials: "Initialer",
      "E.g. H.K": "F.eks. H.K",
      "E.g. H0113": "F.eks. H0113",
      "Cannot be changed": "Kan ikke endres",
      "Shown in the dashboard. Leave empty for vacant rooms.":
        "Vises i dashbordet. La stå tom for ledige rom.",
      "Shown on the wallboard, e.g. H.K":
        "Vises på infoskjermen, f.eks. H.K",
      "Groups rooms on the wallboard": "Grupperer rom på infoskjermen",
      Wards: "Avdelinger",
      "New ward": "Ny avdeling",
      "No ward": "Uten avdeling",
      "Edit Ward": "Rediger avdeling",
      "Ward name": "Avdelingsnavn",
      "Ward name is required": "Avdelingsnavn er påkrevd",
      "Ward updated": "Avdeling oppdatert",
      "Renaming moves every resident in the ward":
        "Endrer du navnet flyttes alle beboerne i avdelingen",
      "Residents in this ward": "Beboere i denne avdelingen",
      "These are manual thresholds you set to raise concerns once the limits are reached.":
        "Dette er manuelle terskler du angir for å vekke bekymringer når grensene er nådd.",
      Hour: "Time",
      Hours: "Timer",
      Minute: "Minutt",
      Minutes: "Minutter",
      "Explore Historical Data from the past 14 days or 30 days or even your preferred custom date range.":
        "Utforsk historiske data fra de siste 14 dagene eller 30 dagene eller til og med din foretrukne egendefinerte datoperiode.",
      "Oops there seems to be no data for the selected days.":
        "Beklager, det ser ikke ut til å være data for de valgte dagene.",
      "view data": "se data",
      "Resident Location Distribution": "Beboerstedsfordeling",
      "Resident Timeline": "Beboer tidslinje",
      "Bar Chart": "Søylediagram",
      "Data from last 7 days": "Data fra siste 7 dager",
      // Room Duration Alerts
      "Room Duration Alerts": "Varslinger for langvarig romopphold",
      "Set up alerts when a resident stays in a room for too long": "Sett opp varsler når en beboer oppholder seg for lenge i et rom",
      "Add Threshold": "Legg til terskel",
      "Edit Threshold": "Rediger terskel",
      "Add Room Duration Threshold": "Legg til terskel for romopphold",
      "Phone number is required when SMS is enabled": "Telefonnummer er påkrevd når SMS er aktivert",
      "Are you sure you want to delete this threshold?": "Er du sikker på at du vil slette denne terskelen?",
      "An error occurred": "En feil oppstod",
      "Failed to load thresholds": "Kunne ikke laste terskler",
      "No room duration thresholds configured": "Ingen terskler for romopphold er konfigurert",
      "Max Duration": "Maks varighet",
      "Max Duration (minutes)": "Maks varighet (minutter)",
      "SMS Notification": "SMS-varsling",
      "Send SMS when threshold exceeded": "Send SMS når terskel overskrides",
      "Notify selected app devices when a room duration alert fires": "Varsle valgte app-enheter når et romoppholdvarsel utløses",
      "Phone Number": "Telefonnummer",
      "Norwegian number or international format": "Norsk nummer eller internasjonalt format",
      "Save": "Lagre",
      "Entrance": "Inngang",
      "Living room": "Stue",
      "Other": "Annet",
      // Door Curfew Alerts
      "Door Exit During Curfew": "Døråpning i portforbudstiden",
      "Door Curfew Alert": "Portforbud-varsel",
      "Alert when resident exits through door during curfew hours": "Varsle når beboer går ut døren i portforbudstiden",
      "Curfew Start": "Portforbud starter",
      "Curfew End": "Portforbud slutter",
      "When curfew period begins": "Når portforbudet begynner",
      "When curfew period ends": "Når portforbudet slutter",
      "Overnight curfew: {{start}} to {{end}} (next day)": "Nattlig portforbud: {{start}} til {{end}} (neste dag)",
      "Same-day curfew: {{start}} to {{end}}": "Portforbud samme dag: {{start}} til {{end}}",
      "Enable Curfew Alert": "Aktiver portforbud-varsel",
      "Send SMS when door opened during curfew": "Send SMS når døren åpnes i portforbudstiden",
      "Are you sure you want to delete the curfew settings?": "Er du sikker på at du vil slette portforbud-innstillingene?",
      "Failed to load curfew settings": "Kunne ikke laste portforbud-innstillinger",
      "Phone Numbers": "Telefonnumre",
      "Phone number already added": "Telefonnummer er allerede lagt til",
      "Repeat alert while unresolved": "Gjenta varsel ved uløst bekymring",
      "Continue alerting on new door events even if the previous concern has not been resolved": "Fortsett å varsle ved nye dørhendelser selv om forrige bekymring ikke er løst",
      "Cooldown between alerts (minutes)": "Ventetid mellom varsler (minutter)",
      "Minimum time between repeated alerts for the same resident": "Minste tid mellom gjentatte varsler for samme beboer",
      "Trigger Mode": "Utløsermode",
      "Door only": "Kun dør — alarm ved døråpning",
      "Motion then door": "Bevegelse, så dør — gangbevegelse kreves",
      "Motion then absence": "Bevegelse, så fravær — alarm hvis ingen aktivitet etter gangbevegelse",
      "Now": "Nå",
      "App Notification": "App-varsel",
      "Notify selected app devices when a curfew alert fires": "Varsle valgte app-enheter når et portforbudvarsel utløses",
      "Alert type": "Varseltype",
      "Ring (CallKit)": "Ring (CallKit)",
      "Notification (push)": "Varsel (push)",
      "App devices to notify": "App-enheter som skal varsles",
      "No devices have registered yet": "Ingen enheter er registrert ennå",
      "Send test alert": "Send testvarsel",
      "Failed to send test alert": "Kunne ikke sende testvarsel",
      "Test alert sent: {{devices}} app device(s), {{sms}} SMS (type: {{type}})": "Testvarsel sendt: {{devices}} app-enhet(er), {{sms}} SMS (type: {{type}})",
      "Sends a test alert to configured devices and SMS numbers, marked as [TEST].": "Sender testvarsel til konfigurerte enheter og SMS-numre, merket med [TEST].",
      // Room duration sensor health & validation
      "Minimum threshold for this room is {{min}} minutes": "Minste terskel for dette rommet er {{min}} minutter",
      "minimum {{min}} min": "minst {{min}} min",
      "sensors silent": "sensorer stille",
      "The motion sensors in this room have not reported recently — alerts will not work until they are back online.": "Bevegelsessensorene i dette rommet har ikke rapportert nylig — varsling vil ikke fungere før de er tilbake.",
      "No other room has healthy motion sensors — the system cannot detect when the resident leaves, which will cause false alerts.": "Ingen andre rom har friske bevegelsessensorer — systemet kan ikke oppdage når beboeren forlater rommet, noe som vil gi falske varsler.",
      "No rooms with motion sensors are registered for this resident — room duration alerts cannot be configured.": "Ingen rom med bevegelsessensorer er registrert for denne beboeren — romoppholdvarsler kan ikke konfigureres.",
      // Room names (Bathroom/Bedroom/Kitchen/Hallway) are already translated
      // earlier in this block — do not redefine them here (duplicate keys win
      // last and would silently override the existing values).
      // Room duration active period
      "Active period": "Aktiv periode",
      "Only alert during this time window. Leave empty to alert around the clock. Spans midnight if end is before start.": "Varsle kun i dette tidsvinduet. La stå tomt for å varsle hele døgnet. Går over midnatt hvis slutt er før start.",
      From: "Fra",
      To: "Til",
      "Around the clock": "Hele døgnet",
      "Set both a start and end time for the active period, or neither": "Angi både start- og sluttid for aktiv periode, eller ingen av dem",
      "Active period start and end time must differ": "Start- og sluttid for aktiv periode må være forskjellige",
    },
  },
  fr: {
    translation: {
      Search: "Rechercher…",
      "Welcome back": "Bon retour",
      "We've missed you": "Tu nous as manqué",
    },
  },
  de: {
    translation: {
      Search: "Suchen…",
      "Welcome back": "Willkommen zurück",
      "We've missed you": "Wir haben dich vermisst",
    },
  },
  nl: {
    translation: {
      Search: "Zoeken…",
      "Welcome back": "Welkom terug",
      "We've missed you": "We hebben je gemist",
    },
  },
};

// const defaultLang = localStorage.setItem("defaultLanguage")

i18n.use(initReactI18next).init({
  resources,
  lng:
    typeof window !== "undefined"
      ? window?.localStorage?.defaultLanguage || "no"
      : "no",
  fallbackLng: "no",
  interpolation: {
    escapeValue: false,
  },
});
